import {Conditions} from "../../@types/Query";
import {isCondition, isConditions} from "../../utils/type-guard";
import ConditionControl from "../ConditionControl/ConditionControl";
import cloneDeep from "lodash/cloneDeep";
import {useStyles} from "./ConditionsControl.styles";
import Button from "../Button/Button";

export const defaultValue: Conditions = {
    entries: [
        {
            field: "content_id",
            compare: "=",
            value: "",
        }
    ],
    relation: "AND",
}

type Props = {
    labels?: {
        and: string
        or: string
        addField: string
        addGroup: string
    },
    conditions: Conditions
    onChange: (conditions: Conditions) => void
    className?: string
}

const ConditionsControl = (
    {
        labels = {
            and: "und",
            or: "oder",
            addField: "+ Bedingung",
            addGroup: "+ Gruppe",
        },
        conditions,
        onChange,
        className = ""
    }: Props
) => {
    const styles = useStyles();
    const handleRelationClick = ()=> {
        const draft = cloneDeep(conditions);
        draft.relation = draft.relation == "AND" ? "OR" : "AND";
        onChange(draft);
    }
    const handleAddEntryClick = ()=> {
        const draft = cloneDeep(conditions);
        draft.entries.push({
            field: "content_id",
            compare: "=",
            value: "",
        });
        onChange(draft);
    }
    const handleAddGroupClick = ()=> {
        const draft = cloneDeep(conditions);
        draft.entries.push({
            relation: "OR",
            entries: [
                {
                    field: "content_id",
                    compare: "=",
                    value: "",
                }
            ],
        });
        onChange(draft);
    }
    const handleDelete = (index: number) => () => {
        const draft = cloneDeep(conditions);
        draft.entries.splice(index, 1);
        onChange(draft);
    }
    const {
        relation,
        entries,
    } = conditions;
    return (
        <div className={`${styles.component} ${className}`}>
            <div className={`${styles.relation} ${styles[`relation_${relation == "AND" ? "and" : "or"}`]}`}>
                <Button
                    className={styles.relationButton}
                    onClick={handleRelationClick}
                >
                    {conditions.relation == "AND" ? labels.and : labels.or}
                </Button>
            </div>
            <div className={styles.entries}>
                {entries.map((entry, index) => {
                    return <div key={index} className={styles.entry}>
                        {isCondition(entry) ? <ConditionControl
                            condition={entry}
                            onChange={(value) => {
                                const draft = cloneDeep(conditions);
                                draft.entries[index] = value;
                                onChange(draft);
                            }}
                        /> : null}
                        {isConditions(entry) ? <ConditionsControl
                            conditions={entry}
                            onChange={(value) => {
                                const draft = cloneDeep(conditions);
                                draft.entries[index] = value;
                                onChange(draft);
                            }}
                        /> : null}
                        {entries.length > 1 ?
                            <div
                                className={styles.entryControls}
                            >
                                <Button
                                    variant="error"
                                    className={styles.entryDelete}
                                    onClick={handleDelete(index)}
                                >
                                    X
                                </Button>
                            </div>
                            :
                            null
                        }

                    </div>
                })}
                <div className={styles.addWrapper}>
                    <Button
                        variant="outline"
                        className={styles.addEntryButton}
                        onClick={handleAddEntryClick}
                    >
                        {labels.addField}
                    </Button>
                    <Button
                        variant="outline"
                        className={styles.addEntryButton}
                        onClick={handleAddGroupClick}
                    >
                        {labels.addGroup}
                    </Button>

                </div>

            </div>
        </div>
    )
}

export default ConditionsControl;